import { Children, type ElementType, type ReactNode } from 'react';
import { clsx } from 'clsx';
import { Grid } from '@interxfi/design-system/components/alignment/grid';
import { type DefaultVerticalStackElement, VerticalStack, type VerticalStackProps } from '../../alignment/vertical-stack';
import styles from './drawer.module.scss';

export function DrawerContent<AsComponent extends ElementType = DefaultVerticalStackElement>(props: VerticalStackProps<AsComponent>) {
  return <VerticalStack align="space-between" {...props} className={clsx(styles.innerContainer, props.className)} />;
}

interface DrawerButtonRowProps {
  children: ReactNode;
  hidden?: boolean;
  preSlot?: ReactNode;
  showBackground?: boolean;
}

export function DrawerButtonRow({ children, hidden, preSlot, showBackground }: DrawerButtonRowProps) {
  const count = Children.toArray(children).filter(Boolean).length;

  return (
    <VerticalStack className={clsx(styles.buttonRow, showBackground && styles.showBackground)} gap={2} hidden={hidden}>
      {preSlot}

      <Grid autoColumns={count} gap={4}>
        {children}
      </Grid>
    </VerticalStack>
  );
}
